export default function LightBlueCursor() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 46 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.12891 3.34326L12.7114 48.6564L21.7759 29.418L42.9116 27.0591L3.12891 3.34326Z" fill="#01B4EE" stroke="black" stroke-width="5.30401" stroke-linejoin="round" />
        </svg>


    )
} 